import React, { useEffect, useState } from 'react';
import './styles.scss'
import CheckedCheckbox from './checked-checkbox.svg';
import PartialCheckbox from './partial-checkbox.svg';
import UncheckedCheckbox from './unchecked-checkbox.svg';
import Box from '../Box';
import { useSuiTheme } from 'baseStyles/ThemeProvider';

interface ICheckboxProps {
    className?: string; 
    onClick?: (value: CheckboxValue) => void;
    checked: CheckboxValue;
};

export enum CheckboxValue {
    UNCHECKED = 'unchecked',
    INDETERMINATE = 'partial',
    CHECKED = 'checked'
}

const Checkbox: React.FC<ICheckboxProps> = ({checked = CheckboxValue.UNCHECKED, className, onClick}) => {
    const { theme } = useSuiTheme();
    const [checkboxValue, setCheckboxValue] = useState<CheckboxValue>(checked);

    const handleClick = () => {
        let toReturn: CheckboxValue;

        switch(checkboxValue){
            case CheckboxValue.CHECKED:
                toReturn = CheckboxValue.UNCHECKED;
                break;
            case CheckboxValue.INDETERMINATE:
                toReturn = CheckboxValue.UNCHECKED;
                break;
            case CheckboxValue.UNCHECKED:
                toReturn = CheckboxValue.CHECKED;
                break;
        }
        
        setCheckboxValue(toReturn);
        onClick(toReturn);
    }

    const renderStatus = () => {
        switch(checkboxValue){
            case CheckboxValue.CHECKED:
                return <CheckedCheckbox fill={theme.checkboxFillColor}/>
            case CheckboxValue.INDETERMINATE:
                return <PartialCheckbox />
            case CheckboxValue.UNCHECKED:
                return <UncheckedCheckbox stroke={theme.checkboxEmptyColor}  />
            default:
                return <UncheckedCheckbox stroke={theme.checkboxEmptyColor} />
        }
    }

    useEffect(() => {
        setCheckboxValue(checked);
    }, [checked])
    

    return (
        <Box onClick={onClick ? () => handleClick?.() : null} className={`sui-checkbox ${className ? className : ''}`}>
            <div className="sui-checkbox__status">{renderStatus()}</div>
        </Box>
    )
};

export default Checkbox;